import * as Highcharts from 'highcharts';
import {ChartTemplateService} from '../../../charts-templates/chart-template.service'; // NOSONAR
import {ChartsDurchschnittlicherBeschaeftigungsgrad} from 'shared/dtos/cockpit/charts/chartsDurchschnittlicherBeschaeftigungsgrad'; // NOSONAR
import {
  DURSCHNITT,
  VAE
} from 'shared/EnumsConstants/card-charts-translate-keys.enum'; // NOSONAR
import {Component, Inject, Input, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {WINDOW} from '@oblique/oblique';

@Component({
  selector: 'app-chart-durchschnittlicher-beschaeftigungsgrad',
  templateUrl: './chart-durchschnittlicher-beschaeftigungsgrad.component.html',
  styleUrl: '../../../../cockpit-shared/card/card.component.scss',
  providers: [ChartTemplateService],
  standalone: false
})
export class ChartDurchschnittlicherBeschaeftigungsgradComponent implements OnInit {
  chart: any;
  isDurschnittSelected = false;
  series: ChartsDurchschnittlicherBeschaeftigungsgrad;
  crtSeries: string;
  durschnitt: string = DURSCHNITT;
  vae: string = VAE;

  constructor(
    @Inject(ChartTemplateService)
    private readonly chartTemplateService: ChartTemplateService,
    private readonly translateService: TranslateService,
    @Inject(WINDOW) private readonly window
  ) {}

  @Input() set durchschnittlicherBeschaeftigungsgrad(
    series: ChartsDurchschnittlicherBeschaeftigungsgrad
  ) {
    if (series) {
      this.series = series;
      this.initialize(this.series);
    }
  }

  ngOnInit(): void {
    this.translateService.onLangChange.subscribe(() => {
      const svgContainer = document.getElementById(
        'svgContainerChartDurchschnittlicherGeschaeftigungsgrad'
      );
      if (svgContainer) {
        this.initialize(this.series);
      }
    });
  }

  initialize(series: ChartsDurchschnittlicherBeschaeftigungsgrad) {
    this.chartTemplateService.chartname =
      'durchschnittlicherBeschaeftigungsgrad';
    this.initHighCharts(JSON.parse(series.seriesVAE));
    this.toggleDisplayChartSerie(this.chart);
  }

  selectionDurschnittOrVaeChanged(item) {
    this.isDurschnittSelected = item.value === DURSCHNITT;
    this.toggleDisplayChartSerie(this.chart);
  }

  private toggleDisplayChartSerie(chart: any) {
    if (!chart.hasLoaded) {
      this.intitializeChart();
      chart = this.chart;
    }
    this.crtSeries = this.isDurschnittSelected
      ? this.series.seriesBG
      : this.series.seriesVAE;

    if (!chart.series) {
      this.initHighCharts(JSON.parse(this.crtSeries));
    }

    this.setDisplayInfoStackedCharts(this.chart);
  }

  private setDisplayInfoStackedCharts(chart: Highcharts.Chart) {
    let plotOptions = {};

    const pointFormat = this.isDurschnittSelected
      ? '<span style="color:{series.color}">{series.name}</span>: <span style="font-weight:bold;">{point.y}%</span><br/>'
      : '<span style="color:{series.color}">{series.name}</span>: <span style="font-weight:bold;">{point.y}</span><br/>';

    const valueDecimals = 2;
    const tooltip = {
      pointFormat,
      valueDecimals
    } as Highcharts.TooltipOptions;

    const max = this.isDurschnittSelected ? 100 : null;
    const labels = this.isDurschnittSelected ? '{value}%' : null;
    const ticks = this.isDurschnittSelected ? 25 : null;

    const yAxis = {
      min: 0,
      max,
      title: {text: ''},
      labels: {format: labels},
      tickInterval: ticks
    };

    const title = this.isDurschnittSelected
      ? this.translateService.instant(
          'i18n.cockpit.card.chart.personalbestand.durschnitt.title'
        )
      : this.translateService.instant(
          'i18n.cockpit.card.chart.personalbestand.vae.title'
        );

    const series = this.crtSeries
      ? JSON.parse(this.chartTemplateService.translateChart(this.crtSeries))
      : chart.options.series;

    plotOptions = {
      plotOptions: {
        series: {stacking: undefined}
      },
      title: this.chartTemplateService.getTitle(title),
      series,
      tooltip,
      yAxis
    } as Highcharts.Options;

    chart.update(plotOptions, true);
    this.window.dispatchEvent(new Event('resize'));
    chart.reflow();
  }

  private initHighCharts(series: any) {
    const xAxis = {
      categories: [
        this.translateService.instant(
          'i18n.cockpit.card.chart.personalbestand.ma-imStundenlohn'
        ),
        this.translateService.instant(
          'i18n.cockpit.card.chart.personalbestand.ma-imMonatslohn'
        ),
        this.translateService.instant(
          'i18n.cockpit.card.chart.personalbestand.ma-gesamt'
        )
      ]
    };
    const chartTitle = {
      text: this.translateService.instant(
        'i18n.cockpit.card.chart.personalbestand.durschnitt.title'
      ),
      style: {color: '#333333', fontSize: '16px'}
    };
    const yAxis = {
      labelsFormat: '{value}%',
      min: 0,
      max: 100,
      tickInterval: 25,
      titleText: ''
    };
    const legend = {reversed: true};
    const tooltip = {
      pointFormat:
        '<span style="color:{series.color}">{series.name}</span>: <span class="stron</spant.y}%</span><br/>',
      valueDecimals: 0
    };

    this.chartTemplateService.initializeChartValues(
      series,
      chartTitle,
      xAxis,
      yAxis,
      legend,
      '',
      tooltip
    );

    this.intitializeChart();
  }

  private intitializeChart() {
    Highcharts.chart(
      'svgContainerChartDurchschnittlicherGeschaeftigungsgrad',
      this.chartTemplateService.json,
      thechart => {
        this.callBackFuncToNormalizeBarChart(thechart);

        // Observer pour détecter les changements de taille du conteneur
        const resizeObserver = new ResizeObserver(() => {
          if (this.chart) {
            this.chart.reflow();
          }
        });
        resizeObserver.observe(
          document.getElementById(
            'svgContainerChartDurchschnittlicherGeschaeftigungsgrad'
          )
        );
      }
    );
  }

  private callBackFuncToNormalizeBarChart(thechart: any) {
    this.chart = thechart;
    thechart.reflow();
  }
}
